import React, { useState } from "react";
import Header from "./header";
import NavBar from "./navBarContainer";
import $ from "jquery";

const communityData = {
  treasuryWallet: 34566434.456,
  investmentWallet: 34566434.456,
  pawnPrice: 25.34,
  liquidity: 1000,
  pawnNodes: 1000,
  pawnHolders: 1000,
};

export default function Backend() {
  const [CommunityDetails, setCommunityDetails] = useState(communityData);
  return (
    <div className="sidemenu">
      <div className="wrapper">
        <NavBar />
        <div className="dash-community">
          <div id="content">
            <div className="toogle-button">
              <button type="button" id="sidebarCollapse" className="btn ">
                <i className="fas fa-arrow-left" aria-hidden="true"></i>
              </button>
            </div>
            <Header />
            <div className="first-section">
              <div className="row justify-content-around ">
                <div className="value">
                  <div className="row">
                    <div className="col-4 pl-4 align-self-center">
                      <img
                        src="../Asserts/address-icon.svg"
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="col-8 pl-0">
                      <h6>Treasury wallet</h6>
                      <h5>$ -</h5>
                    </div>
                  </div>
                </div>
                <div className="value">
                  <div className="row">
                    <div className="col-4 pl-4 align-self-center">
                      <img
                        src="../Asserts/balance-icon.svg"
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="col-8 pl-0">
                      <h6>Investment wallet</h6>
                      <h5>$ -</h5>
                    </div>
                  </div>
                </div>
                <div className="value">
                  <div className="row">
                    <div className="col-4 pl-4 align-self-center">
                      <img
                        src="../Asserts/your-nodes.svg"
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="col-8 pl-0">
                      <h6>PAWN Price</h6>
                      <h5>$ -</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row justify-content-around hz-space">
                <div className="value">
                  <div className="row">
                    <div className="col-4 pl-4  align-self-center">
                      <img
                        src="../Asserts/total-nodes.svg"
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="col-8 pl-0">
                      <h6>Liquidity</h6>
                      <h5> - </h5>
                    </div>
                  </div>
                </div>
                <div className="value">
                  <div className="row">
                    <div className="col-4 pl-4 align-self-center">
                      <img
                        src="../Asserts/total-nodes.svg"
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="col-8 pl-0">
                      <h6>PAWN Nodes</h6>
                      <h5>-</h5>
                    </div>
                  </div>
                </div>
                <div className="value">
                  <div className="row">
                    <div className="col-4 pl-4 align-self-center">
                      <img
                        src="../Asserts/total-nodes.svg"
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="col-8 pl-0">
                      <h6>PAWN Holders</h6>
                      <h5>-</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
